module.exports = __webpack_public_path__ + "img/JLTP_content_N5.4add3fdf.svg";